import {
  IconDashboard,
  IconPackage,
  IconClipboard,
  IconShield,
  IconBuilding,
  IconLayers,
} from '../../ui/icons';
import { WorkspaceNav } from '../WorkspaceNav';

/**
 * Icon-rail navigation for the Investor workspace: read-only, platform-wide.
 */
const sections = [
  {
    items: [
      { to: '/investor', label: 'Overview', Icon: IconDashboard, end: true },
      { to: '/investor/packages', label: 'Packages', Icon: IconPackage },
    ],
  },
  {
    items: [
      { to: '/investor/activity', label: 'Activity', Icon: IconClipboard },
      { to: '/investor/audit', label: 'Admin audit', Icon: IconShield },
    ],
  },
  {
    items: [
      { to: '/investor/organizations', label: 'Organizations', Icon: IconBuilding },
      { to: '/investor/programs', label: 'Programs', Icon: IconLayers },
    ],
  },
];

export function InvestorIconRail() {
  return <WorkspaceNav ariaLabel="Investor navigation" sections={sections} />;
}
